import {
	autoinject,
	bindable,
	bindingMode,
	customElement,
	PLATFORM,
} from 'aurelia-framework';
import { registerComponent } from '~/forms/customisation-editor/property-meta';

const componentTagName = 'a-fieldset';

registerComponent(componentTagName, {
	name: 'Fieldset',
	requirePath: PLATFORM.moduleName('components/fieldset/fieldset'),
	props: [
		{
			label: 'Title',
			name: 'title',
			type: 'String',
		},
	],
	isSelectable: false,
});

@autoinject
@customElement(componentTagName)
export class Fieldset {
	@bindable({
		defaultBindingMode: bindingMode.oneWay,
	})
	private title: string = '';
}
